import React, { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import crm from '../crm/api';

export default function NotificationsBell() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const load = () => crm.get('/notifications').then(({ data }) => { setItems(data.notifications || []); setUnread(data.unread || 0); }).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);

  const toggle = () => {
    setOpen((o) => !o);
    if (unread) crm.put('/notifications/read').then(() => setUnread(0)).catch(() => {});
  };

  return (
    <div className="relative">
      <button onClick={toggle} aria-label="Notifications" className="w-10 h-10 rounded-2xl surface card-lux flex items-center justify-center relative" style={{ color: 'var(--muted)' }}>
        <Bell size={18} />
        {unread > 0 && <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center">{unread}</span>}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-80 surface rounded-2xl card-lux z-50 overflow-hidden">
            <div className="px-4 py-3 border-b border-[var(--border)] font-bold text-sm" style={{ color: 'var(--text)' }}>Notifications</div>
            <div className="max-h-80 overflow-auto">
              {items.length === 0 && <div className="px-4 py-8 text-center text-sm" style={{ color: 'var(--muted)' }}>You're all caught up 🎉</div>}
              {items.map((n) => (
                <div key={n.id} className="px-4 py-3 border-b border-[var(--border)] flex gap-3" style={{ background: n.read ? 'transparent' : 'var(--acc-soft)' }}>
                  <div className="w-2 h-2 rounded-full mt-1.5 shrink-0" style={{ background: n.read ? 'var(--border)' : 'var(--acc)' }} />
                  <div className="min-w-0">
                    <div className="text-sm font-semibold" style={{ color: 'var(--text)' }}>{n.title}</div>
                    <div className="text-[12px]" style={{ color: 'var(--muted)' }}>{n.body}</div>
                    <div className="text-[10px] mt-0.5" style={{ color: 'var(--muted)' }}>{new Date(n.createdAt).toLocaleString()}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
